export const BLOG_POSTS_PER_PAGE = 12 as const;
